export const chunkify = (array, chunkSize) => {
    return array.reduce((all,one,i) => {
      const ch = Math.floor(i/chunkSize); 
      all[ch] = [].concat((all[ch]||[]),one); 
      return all
    }, [])
  }